import {
         ActivatedRouteSnapshot,
         CanActivate,
         CanActivateChild,
         CanLoad,
         Route,
         Router,
         RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canLoad(route: Route) {
    if (this.authenticationService.isLoggedIn) {
      return true;
    }
    const url = `/${route.path}`;
    this.router.navigate(['/login'], { queryParams: { redirectTo: url } });
    return false;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationService.isLoggedIn) {
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { redirectTo: state.url } });
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/services/auth-guard.service.ts